import {ComponentDesc} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/ComponentDesc';
import {HeadingLabel} from '@mintdata/mint-kit/impl/properties/components/headingLabel/HeadingLabel';
import {Row} from '@mintdata/mint-kit/impl/properties/components/row/Row';
import {Section} from '@mintdata/mint-kit/impl/properties/components/section/Section';
import * as React from 'react';
import {PropertyView} from '../PropertyView';

interface IProps
{
    componentDesc:ComponentDesc;
}

export class ViewportLayout extends React.Component<IProps, any>
{
    public render():JSX.Element
    {
        const {componentDesc} = this.props;

        if( componentDesc.childLayoutProp )
        {
            return (
                <Section>
                    <Row>
                        <HeadingLabel text="Layout of Children" />
                    </Row>
                    <PropertyView
                        hideTitle
                        componentDesc={componentDesc}
                        prop={componentDesc.childLayoutProp}
                    />
                </Section>
            );
        }

        return null;
    }
}
